// extracted by mini-css-extract-plugin
export var mainContainer = "index-module--mainContainer--1M1lF";
export var mainImgContainer = "index-module--mainImgContainer--31G27";
export var mainImg = "index-module--mainImg--1d3dl";
export var selectionMenu = "index-module--selectionMenu--tswkG";
export var slice = "index-module--slice--2FtbE";